// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__26TrK","info":"Note_info__1CGrS","note":"Note_note__17dDh","actions":"Note_actions__3YLBZ"};